import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_promotion",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "form-group mr-b-0em" }
const _hoisted_8 = { class: "form-group mr-b-0em" }
const _hoisted_9 = { class: "form-group mr-b-0em" }
const _hoisted_10 = { class: "form-group mr-b-0em" }
const _hoisted_11 = { class: "form-group mr-b-0em" }
const _hoisted_12 = { class: "form-group mr-b-0em" }
const _hoisted_13 = { class: "col-12 text-right" }
const _hoisted_14 = {
  type: "submit",
  class: "btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_inputText = _resolveComponent("inputText")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_price_input = _resolveComponent("price-input")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestPromoPack)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.action == 'add' ? _ctx.i18n.t('views.clients.promotions.add') :
                            _ctx.i18n.t('views.clients.promotions.edit')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_add_promotion', 'add'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        (_ctx.requestPromoPack)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("form", {
                class: "forms-sample",
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_inputText, {
                    modelValue: _ctx.requestPromoPack.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestPromoPack.name) = $event)),
                    label: _ctx.i18n.t('tables.promotions.name'),
                    v: _ctx.v$.name,
                    disabled: false
                  }, null, 8, ["modelValue", "label", "v"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_inputText, {
                    modelValue: _ctx.requestPromoPack.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestPromoPack.description) = $event)),
                    label: _ctx.i18n.t('tables.promotions.description'),
                    v: _ctx.v$.description,
                    disabled: false
                  }, null, 8, ["modelValue", "label", "v"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_date_field, {
                    modelValue: _ctx.requestPromoPack.start_date,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestPromoPack.start_date) = $event)),
                    label: _ctx.i18n.t('tables.promotions.start_date'),
                    v: _ctx.v$.start_date,
                    disabled: false,
                    fixedDays: 1,
                    isFixedDays: true
                  }, null, 8, ["modelValue", "label", "v"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_date_field, {
                    modelValue: _ctx.requestPromoPack.end_date,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestPromoPack.end_date) = $event)),
                    label: _ctx.i18n.t('tables.promotions.end_date'),
                    v: _ctx.v$.end_date,
                    disabled: false
                  }, null, 8, ["modelValue", "label", "v"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_price_input, {
                    modelValue: _ctx.requestPromoPack.price,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestPromoPack.price) = $event)),
                    label: _ctx.i18n.t('tables.promotions.price'),
                    v: _ctx.v$.price,
                    disabled: false
                  }, null, 8, ["modelValue", "label", "v"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_SingleSelect, {
                    TextLabel: _ctx.i18n.t('tables.subscription_member.pack_id'),
                    trackby: `id`,
                    label: `name`,
                    valueProp: `id`,
                    modelValue: _ctx.requestPromoPack.pack_id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestPromoPack.pack_id) = $event)),
                    placeholder: _ctx.i18n.t('tables.subscription_member.pack_id'),
                    arrayOptions: _ctx.packsList,
                    refs: "packs",
                    v: _ctx.v$.pack_id
                  }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", _hoisted_14, _toDisplayString(_ctx.action == 'add' ? _ctx.i18n.t('button.add') : _ctx.i18n.t('button.edit')), 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emptyState())),
                    class: "btn btn-cancel"
                  }, _toDisplayString(_ctx.i18n.t('button.clean')), 1)
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}